import { createClient } from '@supabase/supabase-js';
import { logger } from './logger';

/**
 * Configuración del cliente de Supabase
 * Las credenciales deben estar en variables de entorno:
 * - VITE_SUPABASE_URL
 * - VITE_SUPABASE_ANON_KEY
 * 
 * En desarrollo: configurar en .env.local
 * En producción (Vercel): configurar en Vercel Dashboard > Settings > Environment Variables
 */
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validación estricta: no permitir valores faltantes
if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  const isDevelopment = import.meta.env.DEV;
  const errorMessage = isDevelopment
    ? '⚠️ Supabase credentials not found in environment variables.\n' +
      'Please create a .env.local file with:\n' +
      '  VITE_SUPABASE_URL=your_supabase_url\n' +
      '  VITE_SUPABASE_ANON_KEY=your_anon_key\n' +
      'See .env.local.example for reference.'
    : '❌ Missing Supabase configuration in production.\n' +
      'Please configure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in Vercel Dashboard > Settings > Environment Variables.';
  
  if (isDevelopment) {
    logger.error(errorMessage);
    throw new Error('Supabase credentials are required. Check console for details.');
  } else {
    // En producción, fallar completamente si no hay credenciales
    throw new Error('Missing Supabase configuration in production environment.');
  }
}

// Validar formato básico de las credenciales
if (!SUPABASE_URL.startsWith('https://') || !SUPABASE_URL.includes('.supabase.co')) {
  throw new Error('Invalid SUPABASE_URL format. Expected: https://*.supabase.co');
}

if (!SUPABASE_ANON_KEY.startsWith('eyJ') && !SUPABASE_ANON_KEY.startsWith('sb_')) {
  logger.warn('SUPABASE_ANON_KEY format may be incorrect. Expected JWT or sb_ prefixed key.');
}

// Crear cliente de Supabase
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
